<script>import { videoAction } from "../../actions";
import { stringArraySomeIncludes } from "../../utils/arrays";
import ButtonBoxWhite from "../elements/buttons/variants/ButtonBoxWhite.svelte";
let videoFormats = ["mp4", "webm", "ogg", "h264", "vp9", "hls"];
export let src;
export let classNames = "";
export let loop = false;
export let autoplay = false;
export let controls = false;
export let muted = false;
export let iframe = false;
export let ratio = "";
export let iframeTitle;
export let isConsent;
export let consentMessage;
export let consentCTALabel;
export let consentCTACallbackFunction;
const checkExtensionInSrc = (src2) => {
  if (Array.isArray(src2)) {
    let bool = false;
    src2.forEach((s) => {
      stringArraySomeIncludes(videoFormats, s.url) && (bool = true);
    });
    return bool;
  } else if (typeof src2 !== "string") {
    return stringArraySomeIncludes(videoFormats, src2.url);
  } else {
    return stringArraySomeIncludes(videoFormats, src2);
  }
};
</script>

{#if src}
	{#if checkExtensionInSrc(src)}
		<p class="text-danger">Please provide video url WITHOUT file extension.</p>
	{:else}
		<div class="relative w-full {ratio}">
			{#if iframe}
				{#if isConsent}
					<iframe
						use:videoAction={src}
						allow={`accelerometer; ${
							autoplay ? `autoplay; ` : ``
						}clipboard-write; encrypted-media; gyroscope; picture-in-picture allowfullscreen`}
						loading="lazy"
						title={iframeTitle}
						class={`${classNames} w-full ${ratio}`}
					/>
				{:else}
					<div
						class="flex flex-col bg-grey-dark opacity-70 items-center justify-center absolute w-full h-full top-0 left-0 space-y-2 lg:space-y-4"
					>
						{#if consentMessage}
							<div class="text-xs lg:text-base text-center text-white w-11/12 lg:w-3/4">
								{@html consentMessage}
							</div>
							{#if consentCTALabel}
								<ButtonBoxWhite
									props={{ label: consentCTALabel, size: 'default' }}
									on:click={consentCTACallbackFunction}
								/>
							{/if}
						{/if}
					</div>
				{/if}
			{:else}
				<video
					use:videoAction={src}
					{autoplay}
					preload={autoplay ? 'auto' : 'none'}
					{controls}
					{loop}
					{muted}
					playsinline={autoplay}
				/>
			{/if}
		</div>
	{/if}
{:else}
	<p class="text-danger">Video url is missing. Please use <code>singleUrl</code> props.</p>
{/if}
